import { FormattedMessage } from 'react-intl';
import { StatefulButton } from '@openedx/paragon';
import { ElementClicked, elementEvents, ElementType } from 'helpers/eventing';
import { getIsCTADisabled, useAppSelector } from 'store';
import { PlaceOrderButtonProps } from './types';

export const PlaceOrderButton = ({
  isCTAPending,
  onClick,
}: PlaceOrderButtonProps) => {
  const isCTADisabled = useAppSelector(getIsCTADisabled);
  const buttonState = isCTAPending
    ? 'pending'
    : isCTADisabled
      ? 'disabled'
      : 'default';

  const placeOrderTagularElement: ElementClicked['webElement'] = {
    elementType: ElementType.Button,
    name: 'place-order-cta',
    text: 'Place Order',
    htmlId: 'place-order-click',
    location: 'checkout',
  };

  const { elementClicked: placeOrderElementClicked } = elementEvents({
    webElement: placeOrderTagularElement,
  });

  const handlePlaceOrderClick = () => {
    placeOrderElementClicked();
    onClick?.();
  };

  return (
    <div className="col-lg-6 form-group float-right">
      <div className="row justify-content-end mt-4">
        <StatefulButton
          block
          id="placeOrderButton"
          variant="primary"
          size="lg"
          type="submit"
          onClick={handlePlaceOrderClick}
          state={buttonState}
          disabledStates={['pending', 'disabled']}
          labels={{
            default: (
              <FormattedMessage
                id="payment.checkout.form.submit.button"
                defaultMessage="Place Order"
                description="Button for submitting the checkout form"
              />
            ),
            pending: (
              <FormattedMessage
                id="payment.checkout.form.submit.button.loading"
                defaultMessage="Placing Order"
                description="Button for submitting the checkout form when it is in the loading state"
              />
            ),
          }}
        />
      </div>
    </div>
  );
};
